module.exports = __webpack_public_path__ + "static/assets/e113aa02e926ad23da7d46fead1231b9.gif";